import type { CardTemplate } from "./types";

interface CardDecorationsProps {
  template: CardTemplate;
  width: number;
  height: number;
  isInstagram?: boolean;
}

/**
 * Purely decorative background elements that vary per template.
 * Returns `null` for the Minimal template (clean background).
 */
export default function CardDecorations({
  template,
  width,
  height,
  isInstagram = true,
}: CardDecorationsProps) {
  if (template === "bold") {
    const step = isInstagram ? 60 : 63;
    const cols = isInstagram ? 18 : 20;
    const rows = isInstagram ? 18 : 10;
    return (
      <>
        <div
          style={{
            position: "absolute",
            top: isInstagram ? -120 : -80,
            right: isInstagram ? -120 : -80,
            width: isInstagram ? 420 : 300,
            height: isInstagram ? 420 : 300,
            borderRadius: "50%",
            background: "rgba(107,72,204,0.12)",
            filter: "blur(80px)",
            zIndex: 0,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: isInstagram ? -100 : -80,
            left: isInstagram ? -80 : 300,
            width: isInstagram ? 360 : 280,
            height: isInstagram ? 360 : 280,
            borderRadius: "50%",
            background: "rgba(33,150,243,0.10)",
            filter: "blur(80px)",
            zIndex: 0,
          }}
        />
        <svg
          style={{ position: "absolute", inset: 0, opacity: 0.04, zIndex: 0 }}
          width={width}
          height={height}
        >
          {Array.from({ length: cols }).map((_, i) => (
            <line key={`v${i}`} x1={i * step} y1="0" x2={i * step} y2={height} stroke="#fff" strokeWidth="1" />
          ))}
          {Array.from({ length: rows }).map((_, i) => (
            <line key={`h${i}`} x1="0" y1={i * step} x2={width} y2={i * step} stroke="#fff" strokeWidth="1" />
          ))}
        </svg>
      </>
    );
  }

  if (template === "classic") {
    return (
      <>
        {/* Rainbow accent bar at top */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: 5,
            background: "linear-gradient(90deg, #6B48CC, #2196F3, #2A9D5C, #F57C00)",
            zIndex: 2,
          }}
        />
        {/* Diagonal stripes */}
        <svg
          style={{ position: "absolute", inset: 0, opacity: 0.025, zIndex: 0 }}
          width={width}
          height={height}
        >
          {Array.from({ length: 25 }).map((_, i) => (
            <line
              key={i}
              x1={i * 90 - height}
              y1="0"
              x2={i * 90}
              y2={height}
              stroke="#fff"
              strokeWidth="1.5"
            />
          ))}
        </svg>
      </>
    );
  }

  return null; // minimal — no decoration
}
